export const useGetValidNoun = (number) => {
    if (number % 100 >= 10 && number % 100 <= 20) return "вкусов";
    if (number % 10 === 1) return "вкус";
    if (number % 10 === 2 || number % 10 === 3 || number % 10 === 4)
        return "вкуса";
    return "вкусов";
};
